module.exports = __webpack_public_path__ + "img/purple.86ffc819.webp";